// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { ENTITY_ATTRIBUTE_MODE } from './../../../types/next/blocks/entityAttributeBlock'
import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'
import { uncastObjectSchema } from './common.zod'
import { dateInputBlockSchema } from './dateInputBlock.zod'
import { referenceIdSchema } from './ids.zod'
import { multipleChoiceBlockSchema } from './multipleChoiceBlock.zod'
import { numberInputBlockSchema } from './numberInputBlock.zod'
import {
  blockReferenceSchema,
  contextParameterReferenceSchema
} from './references.zod'
import { singleChoiceBlockSchema } from './singleChoiceBlock.zod'
import { textInputBlockSchema } from './textInputBlock.zod'

export const entityAttributeModeSchema = z.nativeEnum(ENTITY_ATTRIBUTE_MODE)

const sharedSettingsSchema = z.object({
  readOnly: z.boolean(),
  entitySlug: z.string(),
  entityAttribute: z
    .object({
      id: z.string().optional(),
      name: z.string(),
      label: z.string(),
      type: z.string()
    })
    .optional(),
  renderSettings: uncastObjectSchema
})

export const entityAttributeContextReferenceSchema =
  contextParameterReferenceSchema.extend({
    meaning: z.literal('source')
  })

export const entityAttributeFinderReferenceSchema = blockReferenceSchema.extend(
  {
    meaning: z.literal('source')
  }
)

export const iEntityAttributeBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.ENTITY_ATTRIBUTE),
  settings: blockBaseSettingsSchema.and(
    z.object({
      readOnly: z.boolean(),
      mode: entityAttributeModeSchema
    })
  )
})

export const entityBasedEntityAttributeBlockSchema =
  iEntityAttributeBlockSchema.extend({
    type: z.literal(BLOCK_TYPE.ENTITY_ATTRIBUTE),
    settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
      z.object({
        mode: z.literal(ENTITY_ATTRIBUTE_MODE.ENTITY_BASED)
      })
    ),
    references: z.record(
      referenceIdSchema,
      entityAttributeFinderReferenceSchema
    )
  })

export const contextBasedEntityAttributeBlockSchema =
  iEntityAttributeBlockSchema.extend({
    type: z.literal(BLOCK_TYPE.ENTITY_ATTRIBUTE),
    settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
      z.object({
        mode: z.literal(ENTITY_ATTRIBUTE_MODE.CONTEXT_BASED)
      })
    ),
    references: z.record(
      referenceIdSchema,
      entityAttributeContextReferenceSchema
    )
  })

export const authBasedEntityAttributeBlockSchema =
  iEntityAttributeBlockSchema.extend({
    type: z.literal(BLOCK_TYPE.ENTITY_ATTRIBUTE),
    settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
      z.object({
        mode: z.literal(ENTITY_ATTRIBUTE_MODE.AUTH_BASED)
      })
    ),
    references: z.object({})
  })

export const entityAttributeBlockSchema = z.union([
  entityBasedEntityAttributeBlockSchema,
  contextBasedEntityAttributeBlockSchema,
  authBasedEntityAttributeBlockSchema
])

export const entityAttributeBlockValueSchema = z.object({
  newValue: z.unknown().optional(),
  oldValue: z.unknown().optional(),
  _isValid: z.boolean().optional()
})

export const entityAttributeRenderBlocksSchema = z.union([
  dateInputBlockSchema,
  singleChoiceBlockSchema,
  multipleChoiceBlockSchema,
  numberInputBlockSchema,
  textInputBlockSchema
])
